import mixpanel from "mixpanel-browser";
import { jsonGet, jsonPost } from "../../api";

export const getThreads = async () => await jsonGet(`threads`);

export const createThread = async (dto) => await jsonPost(`threads`, dto);

export async function getUserThreads(userId) {
  return await jsonGet(`users/${userId}/threads`);
}

export async function getThreadMessages(threadId) {
  return await jsonGet(`threads/${threadId}/messages`);
}

export async function sendChatMessage(threadId, dto) {
  mixpanel.track("Send Chat Message");
  return await jsonPost(`threads/${threadId}/messages`, dto);
}
